module.exports = __webpack_public_path__ + "img/20190729161451QQ截图20190729010105.2b89a75c.png";